import { SxProps } from "@mui/system";
import { Theme } from "@mui/material/styles";

import { colors } from "../../../theme/palette";
import MobileAppsBG from "../../../assets/images/Layout/mobile-apps-bg.png";

export const sideNavStyles: SxProps<Theme> = {
  flexShrink: "0",
  width: "255px",
  display: "flex",
  flexDirection: "column",
  gap: "35px",
};

export const sideNavBoxStyles: SxProps<Theme> = {
  width: "100%",
  background: colors.White,
  border: `1px solid ${colors.Gray100}`,
  borderRadius: "8px",
  padding: "23px 14px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "19px",
  height: "fit-content",
};

export const avatarStyles: SxProps<Theme> = {
  width: "80px",
  height: "80px",
  margin: "0 auto",
};

export const nameTextStyles: SxProps<Theme> = {
  textAlign: "center",
};

export const aboutTextStyles: SxProps<Theme> = {
  display: "-webkit-box",
  WebkitBoxOrient: "vertical",
  WebkitLineClamp: 3,
  overflow: "hidden",
  textOverflow: "ellipsis",
  position: "relative",
  textAlign: "center",
};

export const menuListStyles: SxProps<Theme> = {
  padding: "16px 0",
  borderTop: "1px solid #EAECF0",
  borderBottom: "1px solid #EAECF0",
  width: "100%",
  display: "flex",
  flexDirection: "column",
  gap: "8px",
};

export const analyticsSectionStyles: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  gap: "20px",
  width: "100%",
};

export const analyticsListStyles: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  gap: "16px",
};

export const gradientBoxStyles: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  gap: "11px",
  alignItems: "center",
  justifyContent: "center",
  background: "linear-gradient(146deg, #00A76F 0%, #007867 100%)",
  borderRadius: "8px",
  padding: "252px 16px 24px",
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  backgroundImage: `url(${MobileAppsBG})`,
};

export const titleTextStyles: SxProps<Theme> = {
  color: colors.White,
  textAlign: "center",

  fontFamily: "HeadingNowVarTrial",
  fontSize: "20px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "normal",
};

export const descriptionTextStyles: SxProps<Theme> = {
  color: colors.White,
  textAlign: "center",
  fontFamily: "Inter",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "normal",
};

export const linkBoxStyles: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
};

export const linkStyles: SxProps<Theme> = {
  height: "45px",
  width: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "50px",
  background: colors.White,
  cursor: "pointer",
};
